var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-tags"},_vm._l((_vm.value),function(tag){return _c('el-button',{key:tag,class:_vm.selectClass(tag),attrs:{"size":"mini","type":_vm.type},on:{"click":function($event){return _vm.toggleSelect(tag)}}},[_vm._v(_vm._s(tag))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }